import { Component, OnInit, ViewChild, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { LocationdocumentsService } from '../../services/locationdocuments/locationdocuments.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatPaginatorIntl } from '@angular/material';
import { AgentLocationdocsDialogComponent } from '../../components/agent-locationdocs-dialog/agent-locationdocs-dialog.component';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import { DownloadService } from '../../services/download/download.service';
import { AgentLocationdocsDeleteDialogComponent } from '../agent-locationdocs-delete-dialog/agent-locationdocs-delete-dialog.component';
import * as moment from 'moment';
import { GetDocStatusColor } from '../../../shared/globalService';
import { DisableRow } from '../../../shared/globalService';
import { PendingApprovalDialogComponent } from './../pending-approval-dialog/pending-approval-dialog.component';
import { ApproveRejectDialogComponent } from './../approve-reject-dialog/approve-reject-dialog.component';

@Component({
  selector: 'app-agentlocationdocuments',
  templateUrl: './agentlocationdocuments.component.html',
  styleUrls: ['./agentlocationdocuments.component.css']
})
export class AgentlocationdocumentsComponent implements OnInit, OnDestroy {
  public documentsAllowedToUpload = [];
  public hideDropdown: any; 
  public docType: any;
  public agentId: any;
  public locationId: any;
  public tableData: any;
  ispaginationFlag: boolean = false;
  pageSize = 10;
  documentType: any;
  clientDisable: any;
  clientHidden: any;
  public role: string;
  length: any;
  docCategory: any;
  dataNotFoundMsg;
  uploadedFileName;
  dataSource: MatTableDataSource<UserData>;
  displayedColumns = ['DocumentTypeName', 'FileName', 'ExpirationDate', 'UploadedTimeStamp', 'DocumentStatus', 'FileEdit'];
  private subscription: Subscription;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  locationDocuments: any;
  noResults: any;
  errMsg;
  errFlag: boolean = false;
  vendorName;
  placeholder = "Select a Document";
  grey: boolean = false;
  approve_reject_button: boolean = false;
  disable_edit : boolean = false;
  constructor(private downloadService: DownloadService, private locationdocumentsService: LocationdocumentsService, public dialog: MatDialog, public cdRef: ChangeDetectorRef,
              private getDocStatusColor: GetDocStatusColor,
              private disabletheRow: DisableRow) { }

  ngOnInit() {
    this.vendorName = localStorage.getItem('AgentName');
    this.uploadedFileName = 'Vendor Locations - ' + this.vendorName;
    this.agentId = localStorage.getItem("AgentId");
    this.locationId = localStorage.getItem("LocationId");
    this.locationdocumentsService.listOfLocDocs(this.agentId).subscribe(res => {
      if (res.Status == 200 && res.DocumentTypes !== undefined && res.DocumentTypes.length > 0) {
        this.docType = res.DocumentTypes;
        this.docCategory = this.docType[0].Category;
        this.populateDocumentTypeDropDown();
        this.hideDropdownIfEmpty();
      }
      else if (res.DocumentTypes !== undefined && res.DocumentTypes.length == 0) {
        this.dataNotFoundMsg = "Location document types data not found";
        this.errFlag = true;
      }
    }, err => {
      this.errMsg = err;
      this.errFlag = true;
    });
    this.subscription = this.locationdocumentsService.load.subscribe(res => {
      if (res === 'success') {
        this.documentType = '';
        this.bindLocationDocumentsTable();
      }
    });

    this.bindLocationDocumentsTable();

    this.role = localStorage.getItem("Role")
    if (this.role === "PC Client") {
      this.clientDisable = true;
      this.clientHidden = true;
    } else {
      this.clientDisable = false;
      this.clientHidden = false;
    }
  }

  hideDropdownIfEmpty() {
    if(this.documentsAllowedToUpload.length == 0)
      this.hideDropdown = true
    else
      this.hideDropdown = false
  }

  populateDocumentTypeDropDown() {
    const documentTypeFilter = () => true;
    this.documentsAllowedToUpload = this.filterDocumentTypesBy(documentTypeFilter)
  }

  filterDocumentTypesBy(filterDocumentsPredicate) {
    return this.docType.filter(filterDocumentsPredicate)
  }

  placeholderChange() {
    this.placeholder = "Document"
  }

  bindLocationDocumentsTable() {
    this.locationdocumentsService.getLocationListDocuments(this.locationId).subscribe(res => {
      if (res.Status == 200 && res.Documents !== undefined && res.Documents.length > 0) {
        this.paginator.pageIndex = 0;
        this.noResults = '';
        this.locationDocuments = res.Documents;
        for (let i = 0; i < res.Documents.length; i++) {
          if (this.locationDocuments[i].UploadedTimeStamp != '' && this.locationDocuments[i].UploadedTimeStamp != null && this.locationDocuments[i].UploadedTimeStamp != undefined) {
            var momentDate = moment(this.locationDocuments[i].UploadedTimeStamp).format('YYYY/MM/DD');
            this.locationDocuments[i].UploadedTimeStamp = momentDate;
          }
          if (this.locationDocuments[i].ExpirationDate !== '' && this.locationDocuments[i].ExpirationDate !== null && this.locationDocuments[i].ExpirationDate !== undefined) {
            var momentDate = moment(this.locationDocuments[i].ExpirationDate).format('YYYY/MM/DD');
            this.locationDocuments[i].ExpirationDate = momentDate;
          }
        }
        this.dataSource = new MatTableDataSource(this.locationDocuments);
        this.dataSource.sort = this.sort;
        this.length = this.locationDocuments.length;
        if (this.length <= 10) {
          this.ispaginationFlag = false;
        }
        else {
          this.ispaginationFlag = true;
        }
        if (this.paginator.pageIndex > 0 && (this.length % 10 == 0)) {
          this.paginator.pageIndex = this.paginator.pageIndex - 1;
        }
        this.dataSource.paginator = this.paginator;
        const paginatorIntl = new MatPaginatorIntl();
        paginatorIntl.itemsPerPageLabel = 'Items per page';
        paginatorIntl.nextPageLabel = 'Next page';
        paginatorIntl.previousPageLabel = 'Previous page';
        paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
          length = this.length;
          if (length == 0 || pageSize == 0) { return `0 van ${length}`; }
          length = Math.max(length, 0);
          const startIndex = page * pageSize;
          // If the start index exceeds the list length, do not try and fix the end index to the end.
          const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
          const round = Math.ceil(length / 10)
          return `${(startIndex / 10) + 1}  of ${round}`;
        }
        this.dataSource.paginator._intl = paginatorIntl;
      }
      else if (res.Documents !== undefined && res.Documents.length == 0) {
        this.locationDocuments = [];
        this.dataSource = null;
        this.ispaginationFlag = false;
        this.noResults = "No documents found";
      }
    }, err => {
      this.errMsg = err;
      this.errFlag = true;
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  getColor(expirationDate) {
    let todayDate = new Date()
    let currentDate = new Date().setHours(0, 0, 0, 0);
    var targetDate = new Date();
    let futureDate = targetDate.setDate(todayDate.getDate() + 30);
    let future = new Date(futureDate).setHours(0, 0, 0, 0);
    let expDate = new Date(expirationDate).setHours(0, 0, 0, 0);
    if (expDate < currentDate) {
      return "red";
    }
    else if (expDate > future) {
      return "black";
    }
    else {
      return "blue";
    }
  }
  openDialog(docName, type): void {
    docName.DocumentCategory = this.docCategory;
    var new_Data = {
      AGENT_ID: localStorage.getItem('AgentId'),
      DocumentTypeCode: docName.DocumentTypeCode,
      DocumentTypeName: docName.DocumentTypeName,
      DocumentCategory: docName.DocumentCategory
    };
    var Data;
    let dialogRef = this.dialog.open(AgentLocationdocsDialogComponent, {
      width: '600px',
      height: '600px',
      data: { data: type === 'update' ? docName : new_Data, type: type }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.documentType = '';
      this.placeholder = 'Select a Document';
    });
    localStorage.setItem('LocationDocName', docName);
  }
  doctypeChange(docObj) {
    this.openDialog(docObj, 'create');
  }



  editDoc(docName) {
    localStorage.setItem('old', JSON.stringify(docName));
    if (docName.DocumentStatus === "Pending Approval" && (this.role === "PC Site Admin" || this.role === "PC PAR Admin" || this.role === "PC PAR Vendor Relations")) {
      this.validateDoc(docName, 'update');
    } else {
      this.openDialog(docName, 'update');
    }
   
  }

  validateDoc(name, type): void {
    name.DocumentCategory = this.docCategory;

    var new_Data = {
      AGENT_ID: localStorage.getItem('AgentId'),
      DocumentTypeName: name.DocumentTypeName,
      DocumentTypeCode: name.DocumentTypeCode,
      DocumentCategory: name.DocumentCategory
    };
    var Data;

    this.clientHidden = false;
    let dialogRef = this.dialog.open(PendingApprovalDialogComponent, {
      disableClose: true,
      height: '300px',
      width: '600px',
      data: { data: type === 'update' ? name : new_Data, type: type, agent_name: this.vendorName, pagename: 'location' },
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  
  deleteDoc(doc) {
    doc.DocumentCategory = this.docCategory;
    let dialogRef = this.dialog.open(AgentLocationdocsDeleteDialogComponent, {
      width: '400px',
      height: '250px',
      data: doc
    });
  }

  // Get the status color
  getStatusColor(status, updatedBy) {
    let response = this.getDocStatusColor.getStatusColor(status, updatedBy);
    this.approve_reject_button = response['Approve/Reject Button'];
    return response.CSS;
  }

  // Greyout the row if the ststus is in inprogress
  disableRow(status, updatedBy) {
    let response = this.disabletheRow.disableRow(status, updatedBy);
    this.grey = response['Disable'];
    this.disable_edit = response['Disable_Edit'];
    return response.CSS;
  }

  doApproveRejectDialog(docName, type): void {
    docName.DocumentCategory = this.docCategory;
  
    var new_Data = {
      AGENT_ID: localStorage.getItem('AgentId'),
      DocumentTypeName: docName.DocumentTypeName,
      DocumentTypeCode: docName.DocumentTypeCode,
      DocumentCategory: docName.DocumentCategory
    };
    var Data;
  
    this.clientHidden = false;
    let dialogRef = this.dialog.open(ApproveRejectDialogComponent, {
      disableClose: true,
      height: '300px',
      width: '600px',
      data: { data: type === 'update' ? docName : new_Data, type: type, agent_name:  this.vendorName, pagename: 'location' },
  
    });
    dialogRef.afterClosed().subscribe(result => {
  
    });
  }
  
  doApproveReject(docName) {
    this.doApproveRejectDialog(docName, 'update');
  }

}





export interface UserData {
  DocumentTypeName: String;
  FileName: String;
  ExpirationDate: Date;
  UploadedTimeStamp: Date;
  FileEdit: any;
  DocumentStatus: String;
}



// WEBPACK FOOTER //
// ./src/app/components/agentlocationdocuments/agentlocationdocuments.component.ts